import * as React from 'react';

import { useDeviceCondition } from '../../../../../../hooks';
import { AnimationLayout, AnimationElement } from '../../../../../common/Animation';

import { layoutAnimationConfig } from './constants';
import * as styles from './Layout.css';

interface ILayoutProps {
  price: React.ReactNode;
  fromPackage: React.ReactNode;
  packages: React.ReactNode;
  singlePackage: React.ReactNode;
  recommendedPackages: React.ReactNode;
  recommendedPackagesPaymentStatus: React.ReactNode;
}

export const Layout = ({
  price,
  fromPackage,
  packages,
  singlePackage,
  recommendedPackages,
  recommendedPackagesPaymentStatus,
}: ILayoutProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <div className={rootStyle}>
      <AnimationElement layout="position" className={styles['publication']}>
        <div className={styles['price']}>{price}</div>
      </AnimationElement>

      {singlePackage && (
        <AnimationElement layout="position" className={styles['single_package']}>
          {singlePackage}
        </AnimationElement>
      )}

      {fromPackage && (
        <AnimationElement layout="position" className={styles['from_package']}>
          {fromPackage}
        </AnimationElement>
      )}

      {recommendedPackages && (
        <AnimationElement layout="position" className={styles['recommendedPackages']}>
          {recommendedPackages}
        </AnimationElement>
      )}

      {recommendedPackagesPaymentStatus && (
        <AnimationElement layout="position" className={styles['recommendedPackagesPaymentStatus']}>
          {recommendedPackagesPaymentStatus}
        </AnimationElement>
      )}

      <AnimationLayout>
        {packages && (
          <AnimationElement layout="position" className={styles['packages']} {...layoutAnimationConfig}>
            {packages}
          </AnimationElement>
        )}
      </AnimationLayout>
    </div>
  );
};
